export enum ActionType {
  BUTTON_LOADER = 'BUTTON_LOADER',
  PAGE_LOADER = 'PAGE_LOADER'
}
